import { render, staticRenderFns } from "./LoyaltyRewardList.vue?vue&type=template&id=b663198c&scoped=true&"
import script from "./LoyaltyRewardList.vue?vue&type=script&lang=js&"
export * from "./LoyaltyRewardList.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyRewardList.vue?vue&type=style&index=0&id=b663198c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b663198c",
  null
  
)

export default component.exports